var render = function () {
  var _vm$alunoSelecionado$;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "header-marcar_consulta bg-gradient-primary"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('h1', [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "BookOpenIcon",
      "size": "30"
    }
  }), _vm._v(" Alunos ")], 1)]), _c('b-col', {
    attrs: {
      "lg": "8"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSubmitSearch.apply(null, arguments);
      }
    }
  }, [_c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "SearchIcon"
    }
  })], 1), _c('b-form-input', {
    attrs: {
      "placeholder": "Buscar Aluno"
    },
    on: {
      "input": _vm.onSearchInput
    },
    model: {
      value: _vm.filtro.name,
      callback: function callback($$v) {
        _vm.$set(_vm.filtro, "name", $$v);
      },
      expression: "filtro.name"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    staticClass: "mb-1 mb-md-0",
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "font-small-3 font-weight-bold"
  }, [_vm._v("Escola")]), _c('v-select', {
    attrs: {
      "options": _vm.escolaOptions,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Todas as escolas"
    },
    on: {
      "input": _vm.onEscolaChange
    },
    model: {
      value: _vm.filtro.schoolId,
      callback: function callback($$v) {
        _vm.$set(_vm.filtro, "schoolId", $$v);
      },
      expression: "filtro.schoolId"
    }
  })], 1), _c('b-col', {
    staticClass: "mb-1 mb-md-0",
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "font-small-3 font-weight-bold"
  }, [_vm._v("Status")]), _c('v-select', {
    attrs: {
      "options": _vm.statusOptions,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Todos os status"
    },
    on: {
      "input": _vm.onStatusChange
    },
    model: {
      value: _vm.filtro.approved,
      callback: function callback($$v) {
        _vm.$set(_vm.filtro, "approved", $$v);
      },
      expression: "filtro.approved"
    }
  })], 1)], 1)], 1), _vm.fetchedStudents.totalItems ? _c('div', {
    staticClass: "d-flex mb-1"
  }, [_c('div', {
    staticClass: "align-self-center text-muted"
  }, [_vm._v(" Total: "), _c('strong', [_vm._v(_vm._s(_vm.fetchedStudents.totalItems))]), _vm._v(" aluno(s) ")]), _c('b-pagination', {
    staticClass: "ml-auto mb-0",
    attrs: {
      "total-rows": _vm.fetchedStudents.totalItems,
      "per-page": _vm.perPage
    },
    on: {
      "input": _vm.onChangePage
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1) : _vm._e(), _c('b-card', {
    staticClass: "mb-0",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-table', {
    ref: "refUserListTable",
    staticClass: "position-relative",
    attrs: {
      "items": _vm.fetchedStudents.content,
      "responsive": "",
      "fields": _vm.tableColumns,
      "primary-key": "id",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.isSortDirDesc,
      "no-local-sorting": "",
      "show-empty": "",
      "empty-text": "Nenhum aluno encontrado"
    },
    on: {
      "update:sortBy": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sortDesc": function updateSortDesc($event) {
        _vm.isSortDirDesc = $event;
      },
      "update:sort-desc": function updateSortDesc($event) {
        _vm.isSortDirDesc = $event;
      },
      "sort-changed": _vm.onSortChanged
    },
    scopedSlots: _vm._u([{
      key: "cell(school)",
      fn: function fn(data) {
        var _data$item$school;

        return [_c('span', [_vm._v(_vm._s(((_data$item$school = data.item.school) === null || _data$item$school === void 0 ? void 0 : _data$item$school.name) || '-'))])];
      }
    }, {
      key: "cell(respondeuQuiz)",
      fn: function fn(data) {
        return [_c('b-badge', {
          staticClass: "text-capitalize",
          attrs: {
            "pill": "",
            "variant": "light-".concat(_vm.resolveQuizStatusVariant(data.item.respondeuQuiz))
          }
        }, [_vm._v(" " + _vm._s(_vm.resolveQuizStatusText(data.item.respondeuQuiz)) + " ")])];
      }
    }, {
      key: "cell(approved)",
      fn: function fn(data) {
        return [_c('b-badge', {
          staticClass: "text-capitalize",
          attrs: {
            "pill": "",
            "variant": "light-".concat(_vm.resolveUserStatusVariant(data.item.approved))
          }
        }, [_vm._v(" " + _vm._s(_vm.resolveUserStatusText(data.item.approved)) + " ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "link",
            "no-caret": "",
            "right": _vm.$store.state.appConfig.isRTL
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                staticClass: "align-middle text-body",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.approveStudent(data.item.id, !data.item.approved);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": !data.item.approved ? 'CheckIcon' : 'XCircleIcon'
          }
        }), _c('span', {
          staticClass: "align-middle ml-50"
        }, [_vm._v(" " + _vm._s(!data.item.approved ? 'Aprovar' : 'Desaprovar') + " Aluno")])], 1), _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.abrirModalAlterarTurma(data.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EditIcon"
          }
        }), _c('span', {
          staticClass: "align-middle ml-50"
        }, [_vm._v(" Alterar Turma")])], 1), _c('b-dropdown-divider'), _c('b-dropdown-item', {
          attrs: {
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.confirmDeleteStudent(data.item);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "text-danger",
          attrs: {
            "icon": "Trash2Icon"
          }
        }), _c('span', {
          staticClass: "align-middle ml-50 text-danger"
        }, [_vm._v(" Excluir Estudante")])], 1)], 1)];
      }
    }])
  })], 1), _vm.fetchedStudents.totalItems ? _c('div', {
    staticClass: "d-flex mt-1"
  }, [_c('b-pagination', {
    staticClass: "ml-auto",
    attrs: {
      "total-rows": _vm.fetchedStudents.totalItems,
      "per-page": _vm.perPage
    },
    on: {
      "input": _vm.onChangePage
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "modal-alterar-turma",
      "title": "Alterar Turma do Aluno",
      "ok-title": "Salvar",
      "cancel-title": "Cancelar",
      "ok-variant": "primary",
      "cancel-variant": "outline-secondary",
      "ok-disabled": !_vm.modalTurma.classroomId || _vm.salvandoTurma
    },
    on: {
      "ok": _vm.salvarAlteracaoTurma
    }
  }, [_vm.alunoSelecionado ? _c('div', [_c('b-row', {
    staticClass: "mb-1"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-50"
  }, [_c('strong', [_vm._v("Aluno:")]), _vm._v(" " + _vm._s(_vm.alunoSelecionado.fullName) + " ")]), _c('p', {
    staticClass: "mb-50"
  }, [_c('strong', [_vm._v("Escola atual:")]), _vm._v(" " + _vm._s(((_vm$alunoSelecionado$ = _vm.alunoSelecionado.school) === null || _vm$alunoSelecionado$ === void 0 ? void 0 : _vm$alunoSelecionado$.name) || '-') + " ")]), _c('p', {
    staticClass: "text-muted small mb-0"
  }, [_c('strong', [_vm._v("Turma atual:")]), _vm._v(" " + _vm._s(_vm.alunoSelecionado.turmaFormatada || _vm.alunoSelecionado.classroom || '-') + " ")])])], 1), _c('b-form-group', {
    attrs: {
      "label": "Nova Escola",
      "label-for": "modal-escola"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "modal-escola",
      "options": _vm.todasEscolasOptions,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Selecione a Escola"
    },
    on: {
      "input": _vm.onModalEscolaChange
    },
    model: {
      value: _vm.modalTurma.schoolId,
      callback: function callback($$v) {
        _vm.$set(_vm.modalTurma, "schoolId", $$v);
      },
      expression: "modalTurma.schoolId"
    }
  })], 1), _c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Nova Turma",
      "label-for": "modal-turma"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "modal-turma",
      "options": _vm.turmasOptions,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "disabled": !_vm.modalTurma.schoolId || _vm.carregandoTurmas,
      "placeholder": _vm.carregandoTurmas ? 'Carregando turmas...' : !_vm.modalTurma.schoolId ? 'Selecione uma escola primeiro' : 'Selecione a Turma'
    },
    model: {
      value: _vm.modalTurma.classroomId,
      callback: function callback($$v) {
        _vm.$set(_vm.modalTurma, "classroomId", $$v);
      },
      expression: "modalTurma.classroomId"
    }
  })], 1)], 1) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }